import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { SendNewMessage } from './types';
import { MESSAGES_PER_PAGE } from './reducer';
import { addNewMessage, getChatMessagesList, setViewedMessage } from 'src/api/agora/chatMessages';

export const fetchChatMessages = createAsyncThunk(
  'chatMessages/fetchChatMessages',
  async (roomId: string, thunkAPI) => {
    const { chatMessages } = thunkAPI.getState() as RootState;
    let offset = 0;

    if (chatMessages.entities[roomId]) {
      offset = chatMessages.entities[roomId].offset;
    }

    const response = await getChatMessagesList(roomId, MESSAGES_PER_PAGE, offset);
    return response.data;
  }
);

export const addChatNewMessage = createAsyncThunk('chatMessage/addNewMessage', async (data: SendNewMessage) => {
  const response = await addNewMessage(data);
  return response;
});

export const setMessageViewed = createAsyncThunk('chatMessage/setViewedMessage', async (id: string) => {
  const response = await setViewedMessage(id);
  return response.data;
});
